import * as React from 'react';
import { observer } from 'mobx-react';
import Page from '@src/components/page';
import MechaUnitStore from './store';
import TopMenu from '@src/business-components/top-menu';
import Link from '@src/components/link';
import CommonFooter from '@src/business-components/common-footer';
import aos from '@src/utils/aos';
import cx from 'classnames';
import { mechaData } from './mechaUnit';
import { useEffect, useRef } from 'react';

const styles = require('./index.less');

// 机甲列表

const MechaUnit = ({ store }) => {
  store.use();

  const footerBoxRef = useRef(null);

  // 获取 footer 高度并计算背景高度
  useEffect(() => {
    const updateFooterHeight = () => {
      if (footerBoxRef.current) {
        // console.log(footerBoxRef.current.offsetHeight,'footerBoxRef.current.offsetHeight');

        document.documentElement.style.setProperty('--bg-height', `${footerBoxRef.current.offsetHeight}px`);
      }
    };
    updateFooterHeight();

    window.addEventListener('resize', updateFooterHeight);
    return () => window.removeEventListener('resize', updateFooterHeight);
  }, []);

  // 驾驶员信息
  const driverInfo = () => {
    return (
      <div className={styles.driverInfo}>
        <div className={styles.driverName} style={{ backgroundImage: `url(${store.mechaData?.driverName_img})` }} {...aos.FADE_UP()} />
        <div className={cx(styles.familyCrest)} style={{ backgroundImage: `url(${store.mechaData?.familyCrest_img})` }} {...aos.FADE_UP()} />
        <div className={styles.basicInformation} data-name="基础信息">
          <div className={styles.title_text} {...aos.FADE_UP()}>
            <div className={styles.titleIcon} style={{ backgroundImage: `url(${store.mechaData?.titleIcon})` }} {...aos.FADE_UP()} />
            {/* 基础信息 */}
            {mechaData?.basicInformation}
          </div>
          <div className={styles.infoItem} {...aos.FADE_UP()}>
            {/* 性别：女 */}
            {store.mechaData?.driver_sex}
          </div>
          <div className={styles.infoItem} {...aos.FADE_UP()}>
            {/* 出生地：希古尼亚联合体 赫罗兰王国 */}
            {store.mechaData?.driver_birth_place}
          </div>
          <div className={styles.infoItem} {...aos.FADE_UP()}>
            {/* 搭乘机体：矛隼特装型 */}
            {store.mechaData?.driver_mecha_name}
          </div>
          <div className={cx(styles.title_text, styles.title_text2)} {...aos.FADE_UP()}>
            <div className={styles.titleIcon} style={{ backgroundImage: `url(${store.mechaData?.titleIcon})` }} {...aos.FADE_UP()} />
            {/* 角色经历 */}
            {mechaData?.roleExperience}
          </div>
          <div className={cx(styles.infoItem, styles.infoItem2, styles.driverInfoItem)} {...aos.FADE_UP()} data-name="角色经历详情">
            {store.mechaData?.driver_role_desc}
          </div>
          <div className={cx(styles.cvTitle)} {...aos.FADE_UP()}>
            <div className={styles.cvTitleIcon} style={{ backgroundImage: `url(${store.mechaData?.cvTitleIcon})` }} {...aos.FADE_UP()} />
            {/* 驾驶员语音 */}
            {mechaData?.driverVoice}
          </div>
          <div className={cx(styles.cvTabBox)} style={{ backgroundImage: `url(${store.mechaData?.cvTabBox})` }} {...aos.FADE_UP()}>
            {store.cvTab?.map((item, tabIndex) => {
              return (
                <div
                  key={tabIndex}
                  className={cx(styles.cvTabBtn, tabIndex === store.cvTabIndex && styles.cvTabBtnActive)}
                  style={{
                    backgroundImage: `url(${tabIndex === store.cvTabIndex && store.mechaData?.cvTabBtnActive})`
                  }}
                  onClick={() => {
                    store.switchCvTab(tabIndex, item.langType);
                  }}
                >
                  <div>{item.lang}</div>
                  <div>{item.name}</div>
                </div>
              );
            })}
          </div>
          <div className={styles.cvList} {...aos.FADE_UP()}>
            {store.cvList?.map((item, index) => {
              return (
                <div
                  key={index}
                  className={cx(styles.cvItem, item.isPlay && styles.cvItemActive)}
                  style={{
                    backgroundImage: `url(${item.isPlay ? store.mechaData?.cvItemActive : store.mechaData?.cvItem})`
                  }}
                >
                  <Link
                    className={cx(styles.cvcvAudioPlay, item.isPlay && styles.cvcvAudioPause)}
                    style={{
                      backgroundImage: `url(${item.isPlay ? store.mechaData?.cvcvAudioPause : store.mechaData?.cvcvAudioPlay})`
                    }}
                    onClick={() => {
                      store.onClickPlayRoleAudio(item, index);
                    }}
                  />
                  <div className={cx(styles.cv_item_phrase)}>{item.phrase}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  // 特装机甲信息
  const mechaInfo = () => {
    return (
      <div className={styles.mechaInfo}>
        <div className={cx(styles.mechaName)} style={{ backgroundImage: `url(${store.mechaData?.mechaName_img})` }} {...aos.FADE_UP()} />
        <div className={styles.basicInformation} data-name="基础信息">
          <div className={styles.title_text} {...aos.FADE_UP()}>
            <div className={styles.titleIcon} style={{ backgroundImage: `url(${store.mechaData?.titleIcon})` }} {...aos.FADE_UP()} />
            {/* 基础信息 */}
            {mechaData?.basicInformation}
          </div>
          <div className={styles.infoItem} {...aos.FADE_UP()}>
            {/* 机体编号：UBP-R02C */}
            {store.mechaData?.mecha_number}
          </div>
          <div className={styles.infoItem} {...aos.FADE_UP()}>
            {/* 头顶高：14.7米 */}
            {store.mechaData?.mecha_head_height}
          </div>
          <div className={styles.infoItem} {...aos.FADE_UP()}>
            {/* 空重：13.8吨 */}
            {store.mechaData?.mecha_empty_weight}
          </div>
          <div className={styles.infoItem} {...aos.FADE_UP()}>
            {/* 全重：16.1吨 */}
            {store.mechaData?.mecha_full_weight}
          </div>
          <div className={cx(styles.title_text, styles.title_text2)} {...aos.FADE_UP()}>
            <div className={styles.titleIcon} style={{ backgroundImage: `url(${store.mechaData?.titleIcon})` }} {...aos.FADE_UP()} />
            {/* 机兵故事 */}
            {mechaData?.mecha_story_tips}
          </div>
          <div className={cx(styles.infoItem, styles.infoItem2)} style={{ textAlign: 'start' }} {...aos.FADE_UP()} data-name="机体背景详情">
            {store.mechaData?.mecha_story_desc}
          </div>
          <div className={styles.manufacturer} {...aos.FADE_UP()}>
            <div className={styles.manufacturerIcon} style={{ backgroundImage: `url(${store.mechaData?.manufacturerIcon})` }} {...aos.FADE_UP()} />
            {/* 生产商 */}
            {mechaData?.manufacturer}
          </div>
          <div className={styles.manufacturer_name} {...aos.FADE_UP()}>
            <div className={styles.triangle_icon} {...aos.FADE_UP()} />
            {/* 比弗罗斯特工业集团 */}
            {store.mechaData?.mecha_factory_name}
          </div>
          <div className={styles.manufacturer_name_en} {...aos.FADE_UP()}>
            {/* Bifrost Industry Corporation */}
            {store.mechaData?.mecha_factory_name_en}
          </div>
          <div className={styles.group_logo} style={{ backgroundImage: `url(${store.mechaData?.group_logo})` }} {...aos.FADE_UP()} />
        </div>
      </div>
    );
  };

  return (
    <Page className={styles.mechaUnit}>
      <div className={cx(styles.bg, store.currentIndex === 0 ? styles.driver_Bg : styles.mecha_Bg)} style={{ backgroundImage: `url(${store.mechaData?.bg})` }}>
        <TopMenu store={store.topMenuStore} />
        <div className={cx(styles.videoBg)} />
        <Link
          className={styles.returnBtn}
          style={{ backgroundImage: `url(${store.mechaData?.returnBtn})` }}
          onClick={() => {
            store.goBack();
          }}
        />
        <div className={cx(styles.title)} style={{ backgroundImage: `url(${store.mechaData?.mecha_title_img})` }} />
        <div className={cx(styles.driver)} style={{ backgroundImage: `url(${store.mechaInfo?.driver_img})` }} />
        <div className={cx(styles.mecha)} style={{ backgroundImage: `url(${store.mechaInfo?.mecha_img})` }} />
        <Link
          className={cx(styles.videoBtn)}
          style={{ backgroundImage: `url(${store.mechaData?.videoBtn})` }}
          onClick={() => {
            store.openVideo();
          }}
        />
        <div className={cx(styles.mechaUnitGoldenLine)} style={{ backgroundImage: `url(${store.mechaInfo?.bg_kv})` }} />
        {/* info */}
        <div
          className={cx(styles.bgLine, store.currentIndex === 0 ? styles.driverBg : styles.mechaBg)}
          style={{
            backgroundImage: `url(${store.currentIndex === 0 ? store.mechaData?.driverBg : store.mechaData?.mechaBg})`
          }}
        >
          <div className={styles.triangleIcon} style={{ backgroundImage: `url(${store.mechaData?.triangleIcon})` }} data-name="三角形" />
          <div className={styles.tabBox}>
            <Link
              className={cx(styles.tabBtn, styles.driverBtn, store.currentIndex === 0 && styles.driverActiveBtn)}
              style={{ backgroundImage: `url(${store.currentIndex === 0 ? store.mechaData?.driverActiveBtn : store.mechaData?.driverBtn})` }}
              onClick={() => {
                store.switchInfo(0);
              }}
            />
            <Link
              className={cx(styles.tabBtn, styles.mechaBtn, store.currentIndex === 1 && styles.mechaActiveBtn)}
              style={{ backgroundImage: `url(${store.currentIndex === 1 ? store.mechaData?.mechaActiveBtn : store.mechaData?.mechaBtn})` }}
              onClick={() => {
                store.switchInfo(1);
              }}
            />
          </div>

          {store.currentIndex === 0 ? driverInfo() : mechaInfo()}
          <div
            className={styles.gotoTOPbg}
            style={{
              backgroundImage: `url(${store.mechaData?.gotoTOPbg})`
            }}
            {...aos.FADE_UP()}
          >
            <Link
              className={styles.goTopBtn}
              style={{
                backgroundImage: `url(${store.mechaData?.goTopBtn})`
              }}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            />
          </div>
        </div>
        {/* 底栏 */}
        <div className={styles.footerBox} ref={footerBoxRef}>
          <CommonFooter />
        </div>
      </div>
    </Page>
  );
};

export default observer(MechaUnit, MechaUnitStore);
